import { IPublicClientApplication, InteractionRequiredAuthError } from '@azure/msal-browser';
import { logout } from '../utils/logout';

const NO_ACCOUNT_ERROR_MSG = 'No active account! Verify a user has been signed in and setActiveAccount has been called.';

let instance: IPublicClientApplication;

const authApi = {
  logout: () => logout(instance),
  loginRedirect: async () => await instance.loginRedirect(),
  getActiveAccount: () => instance.getActiveAccount(),
  getAuthToken: async (scopes: string[], redirectUri: string) => {
    const account = instance.getActiveAccount();
    if (!account) {
      throw Error(NO_ACCOUNT_ERROR_MSG);
    }
    const request = {
      scopes,
      redirectUri,
      account,
    };

    const tokenResponse = await instance.acquireTokenSilent(request).catch(async error => {
      if (error instanceof InteractionRequiredAuthError) {
        // fallback to interaction when silent call fails
        return instance.acquireTokenRedirect(request);
      }
      throw error;
    });
    return tokenResponse?.accessToken;
  },
};

// We ensure that the authApi is only created once and can be used in effects without triggering rerenders
export default function getInstance(msalInstance: IPublicClientApplication) {
  instance = msalInstance;
  return authApi;
}
